import { useState } from "react";
import { useCartStore } from "@/store/cart-store";
import BulkOrderDialog from "@/v2-components/cart-sheet/bulk-order-dialog";
import BulkOrderInquiryDialog from "@/v2-components/bulk-order-inquiry-dialog";
import { BundleMergedDialog } from "@/components/tactsuit/components/buy-tactsuit/bundle-merged-dialog";
import { useRouter } from "next/router";
import AlertUnavailableBagItems from "@/v2-components/cart-sheet/AlertUnavailableBagItems";
import { useBundledStore } from "@/store/cart-store/useBundledStore";

/**
 * 카트가 시트에서 페이지(/cart)로 전환됨.
 * 이 컴포넌트는 전역으로 필요한 카트 관련 다이얼로그만 렌더링합니다.
 */
export function CartSheet() {
  const cart = useCartStore((c) => ({
    isBulkOrder: c.isBulkOrder,
    setIsBulkOrder: c.setIsBulkOrder,
  }));
  const { isOpen, close, bundle } = useBundledStore((s) => ({
    isOpen: s.isOpen,
    close: s.close,
    bundle: s.bundle,
  }));
  const router = useRouter();
  // develop 유래: 대량주문 다이얼로그의 "문의하기" → 문의 폼 다이얼로그. 시트 UI 는 /cart
  // 페이지로 이관됐지만 이 전역 다이얼로그 흐름은 그대로 살린다.
  // develop 의 isMobile/empty 는 제거 — 시트 본문 렌더링용이었고 여기 셀렉터에는
  // items/gameItems 가 없다(축소된 store 셀렉터). 남기면 런타임 에러.
  const [inquiryOpen, setInquiryOpen] = useState(false);

  return (
    <>
      <BulkOrderDialog
        open={cart.isBulkOrder}
        onOpenChange={() => cart.setIsBulkOrder(false)}
        onContactClick={() => setInquiryOpen(true)}
      />
      {inquiryOpen && (
        <BulkOrderInquiryDialog open onOpenChange={setInquiryOpen} />
      )}
      {/* 번들 병합 모달 (#5356). **전역** 다이얼로그라 어느 화면에서 병합돼도 뜬다.
          `View Bag` 는 이미 /cart 에 있어도 무해하다(같은 라우트 push).
          종전 `BundledDialog`(제목 + "discount applied!" + `OK` 하나)를 대체한다. */}
      <BundleMergedDialog
        open={isOpen}
        bundleSlug={bundle}
        onClose={close}
        onViewCart={() => {
          close();
          router.push("/cart");
        }}
      />
      <AlertUnavailableBagItems />
    </>
  );
}
